import { Glue42 } from "../../../glue";
import jumpListManager from "./manager";

export default class JumpListActions implements Glue42.Windows.JumpListActionsAPI {

    private _categoryTitle: string;

    constructor(private windowId: string, configuration: Glue42.Windows.JumpListCategorySettings) {
        this._categoryTitle = configuration.title;
    }

    public list(): Promise<Glue42.Windows.JumpListActionSettings[]> {
        return jumpListManager.getActions(this.windowId, this._categoryTitle);
    }

    public create(actions: Glue42.Windows.JumpListActionSettings[]): Promise<void> {
        return jumpListManager.createActions(this.windowId, this._categoryTitle, actions);
    }

    public remove(actions: Glue42.Windows.JumpListActionSettings[]): Promise<void> {
        return jumpListManager.removeActions(this.windowId, this._categoryTitle, actions);
    }
}
